module.exports = __webpack_public_path__ + "static/media/pumping-iron.9eae8cd0.svg";